var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    { class: ["header padding-y-2xl", { "padding-top-4xl": _vm.accountView }] },
    [
      _vm.hasLimitedOfferBadge
        ? _c(
            "div",
            {
              staticClass: "position-absolute",
              staticStyle: {
                top: "calc(var(--spacing-2xl) * -1)",
                right: "calc(var(--spacing-2xl) * -1)",
                transform: "rotate(15deg)",
              },
            },
            [
              _c(
                "div",
                { staticClass: "position-relative text-center" },
                [
                  _c("font-awesome-icon", {
                    staticClass: "position-relative z-1",
                    staticStyle: { color: "var(--fa-yellow)" },
                    attrs: { icon: _vm.$v7.solid.faCertificate, size: "7x" },
                  }),
                  _vm._v(" "),
                  _vm._m(0),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("font-awesome-icon", {
        attrs: { icon: _vm.$v7[_vm.planIconStyle][_vm.icon], size: "4x" },
      }),
      _vm._v(" "),
      !_vm.plan && !_vm.subscription && _vm.determinations.isBacker
        ? _c("h3", { staticClass: "margin-top-md" }, [
            _c("span", { staticClass: "display-block size-sm" }, [
              _vm._v("Font Awesome 5"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "display-block size-lg" }, [
              _vm._v("Early Backer"),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.planName
        ? _c("h3", { staticClass: "margin-y-4xs size-4xl" }, [
            _vm._v("\n    " + _vm._s(_vm.planName) + "\n    "),
            _c("span", { staticClass: "sr-only" }, [_vm._v("Plan")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      (_vm.plan || _vm.subscription) && !_vm.accountView
        ? _c("dl", { staticStyle: { "--list-padding-left": "0" } }, [
            _c("dt", { staticClass: "sr-only" }, [_vm._v("Cost:")]),
            _vm._v(" "),
            _c(
              "dd",
              {
                staticClass: "text-center margin-bottom-0",
                staticStyle: { "font-weight": "var(--font-weight-semibold)" },
              },
              [
                _c("span", { staticClass: "display-flex align-center" }, [
                  _c(
                    "span",
                    {
                      staticClass: "size-3xl",
                      staticStyle: { "line-height": "var(--line-height-sm)" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.currentDollars()) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.currentCents()
                    ? _c(
                        "span",
                        {
                          staticClass: "padding-top-4xs",
                          staticStyle: {
                            "align-self": "flex-start",
                            "font-size": "var(--font-size-lg)",
                          },
                        },
                        [_vm._v("." + _vm._s(_vm.currentCents()))]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "display-block text-capitalize" }, [
                  _vm._v(_vm._s(_vm.howLong)),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.hasAdditionalPricingDetails
              ? _c("dd", [
                  _vm._v("\n      then " + _vm._s(_vm.nextYearDollars())),
                  _vm.nextYearCents()
                    ? _c("span", [_vm._v("." + _vm._s(_vm.nextYearCents()))])
                    : _vm._e(),
                  _vm._v("/year\n    "),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass:
          "position-absolute z-2 display-block top-1 right-1 padding-lg",
      },
      [
        _c(
          "span",
          {
            staticClass: "display-block margin-top-2xs",
            staticStyle: {
              "line-height": "1.2",
              "font-weight": "var(--font-weight-semibold)",
            },
          },
          [_vm._v("Limited Time Price!")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }